import { flyerGibs as initialState } from 'flux/initialState';
import { flyerGibs as actions } from 'flux/actions';

export default function (state = initialState, action) {
  const { types } = actions;

  switch (action.type) {
    case types.RESET: {
      const { resetState } = action.payload;
      return { ...resetState, fetched: true };
    }
    default:
      return state;
  }
}
